import React, { useState, useRef } from "react";
import "./PlanSelection.css";

const PlanSelection = ({ plan, setPlan, paymentCycle, setPaymentCycle, nextStep }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("פרימיום");
  const termsRef = useRef(null);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handlePlanSelection = (selectedPlan) => {
    setPlan(selectedPlan);
    setSelectedPlan(selectedPlan); // Store selected plan
  };

  // Plan data with both monthly and yearly options
  const plans = {
    monthly: [
      {
        name: "בסיס",
        price: 199,
        yearlyPrice: 179 * 12,
        description: "חבילת הבסיס לעסק שלכם",
      },
      {
        name: "פרימיום",
        price: 399,
        yearlyPrice: 379 * 12,
        recommended: true,
        description: "חבילת הפרימיום לעסק שלכם",
      },
      {
        name: "ארגונים",
        price: 1199,
        yearlyPrice: 1179 * 12,
        description: "חבילה מותאמת לארגון גדול",
      },
    ],
  };

  // Handle payment cycle change
  const handlePaymentCycleChange = (cycle) => {
    setPaymentCycle(cycle); // Set payment cycle (monthly or yearly)
  };

  return (
    <div className="plan-selection-wrapper">
      <div className="plan-selection-container" dir="rtl">
        <h2 className="plan-selection-container-h2">בחירת מסלול</h2>

        {/* Billing cycle toggle */}
        <div className="billing-toggle">
          <button
            className={paymentCycle === "monthly" ? "active" : ""}
            onClick={() => handlePaymentCycleChange("monthly")}
          >
            תשלום חודשי
          </button>
          <button
            className={paymentCycle === "yearly" ? "active" : ""}
            onClick={() => handlePaymentCycleChange("yearly")}
          >
            תשלום שנתי
          </button>
        </div>

        {/* Plans list */}
        <div className="plans-container-selection">
          {plans.monthly.map((planItem, index) => (
            <div
              key={index}
              className={`plan-card-selection ${
                selectedPlan === planItem.name ? "recommended-selection" : ""
              }`}
            >
              {planItem.name === "פרימיום" && (
                <div className="recommended-badge-selection">המומלץ ביותר</div>
              )}

              <h3 className="plan-name-selection">{planItem.name}</h3>
              <p className="plan-description-selection">{planItem.description}</p>
              <p className="plan-price-selection">
                ₪
                {paymentCycle === "monthly"
                  ? planItem.price
                  : Math.floor((planItem.yearlyPrice /12 ))} {/* Apply 10% discount for yearly */}
                {/* <span> {paymentCycle === "monthly" ? "לחודש" : "לשנה"}</span> */}

                <span>לחודש</span>
              </p>

              <p className="plan-yearly-selection">
                {paymentCycle === "yearly" && (
                  <span>
                    בחשבון אחד של ₪ {planItem.yearlyPrice.toLocaleString()} (לפני
                    מע"מ)
                  </span>
                )}
              </p>

              <button
                className="try-button-selection"
                onClick={() => {
                  handlePlanSelection(planItem.name);
                  setSelectedPlan(planItem.name);
                }}
              >
                בחירת תכנית
              </button>
            </div>
          ))}
        </div>

        {/* Terms and checkbox */}
        <div ref={termsRef} className="terms-checkbox-container">
          <input
            type="checkbox"
            id="terms-checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="terms-checkbox"
          />
          <label htmlFor="terms-checkbox" className="terms-label">
            אני מסכים ל
            <a
              href="/TermOfUse"
              target="_blank"
              rel="noopener noreferrer"
              className="terms-link"
            >
              {" "}
              EULA (הסכם רישוי למשתמש)
            </a>
          </label>
        </div>

        {plan && (
          <div className="plan-selected">
            <h3>
              איזה כיף ! בחרת בחבילת:{" "}
              <span className="plan-selected-highlight"> {plan} ✅</span>
            </h3>
          </div>
        )}

        <br />

        {/* Next button */}
        <button
          className="next-button"
          onClick={nextStep}
          disabled={!plan || !isChecked}
        >
          הבא
        </button>
      </div>
    </div>
  );
};

export default PlanSelection;
